import { LoadingGate } from "@/components/LoadingGate/LoadingGate";
import { useRedirection } from "@/hooks/use-redirection";
import { Outlet } from "@tanstack/react-router";

/**
 * Protects routes that require authentication or group access.
 */
export const AuthenticationGuard = () => {
  const { isInitializing } = useRedirection();

  return (
    <LoadingGate loading={isInitializing}>
      <Outlet />
    </LoadingGate>
  );
};
